/**
* Cart terms
*/
const termsOverlay = document.querySelector('.terms-overlay');
const termsWrapper = document.querySelector('.terms-wrapper');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');


window.showTerms = function showTerms() {
  termsOverlay.classList.add('terms-overlay--active');
  termsContent.classList.add('terms-content-wrapper--active');
  termsWrapper.classList.add('terms-wrapper--active');
}

function hideTerms() {
  termsOverlay.classList.remove('terms-overlay--active');
  termsContent.classList.remove('terms-content-wrapper--active');
  termsWrapper.classList.remove('terms-wrapper--active');
}

termsOverlay.addEventListener('click', hideTerms);

termsAccept.addEventListener('click', () => {
  window.location = '/checkout';
});

termsDeny.addEventListener('click', hideTerms);

document.addEventListener('cart:closing', hideTerms);

function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {

    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

// Collection Page - Load More Button - Fetch
let page = 2;

function loadMore() {
  const collectionGet = document.querySelector('[data-product-grid]');
  const loadMoreBtn = document.querySelector('[data-paginate-next]');
  if (loadMoreBtn) {
    var searchParams = removeURLParameter(location.search, 'p').replace('?', '')
    const url = loadMoreBtn.getAttribute('href');
    const pages = +collectionGet.lastElementChild.dataset.pages;

    if (pages === 1) {
      loadMoreBtn.hidden = true;
    }

    if (page === pages) {
      loadMoreBtn.hidden = true;
    }

    loadMoreBtn.addEventListener('click', function (e) {
      loadMoreBtn.disabled = true
      e.preventDefault();
      window.history.pushState({}, '', location.pathname + '?p=' + page);

      fetch(url + '?view=ajax&page=' + page + '&' + searchParams)
        .then(response => response.text())
        .then(response => {
          collectionGet.insertAdjacentHTML('beforeend', response);

          page++;
          collectionColorSwatches()
          theme.reinitProductGridItem();
          loadMoreBtn.disabled = false
        })
        .catch(error => {
          console.log("Error", error);
        });
    });
  }
}
loadMore();
document.addEventListener('collection:reloaded', () => {
  loadMore();
  collectionColorSwatches();
});

function loadToPage(pages) {
  const collectionGet = document.querySelector('[data-product-grid]');
  let i = 2,
    urls = [];

  do {
    urls.push(fetch(`${location.pathname}?view=ajax&page=${i}`))
    i++;
  } while (i <= pages)
  Promise.all(urls).then(responses =>
    Promise.all(responses.map(res => res.text()))
  ).then(data => {
    data.forEach(html => {
      collectionGet.insertAdjacentHTML('beforeend', html);
    })
    collectionColorSwatches();
    theme.reinitProductGridItem();
    page = pages + 1;
    if (pages === +loadMoreBtn.dataset.pages) {
      loadMoreBtn.hidden = true;
    }
  })
}

if (location.pathname.includes('/collections/') && !location.pathname.includes('/products/') && location.search.includes('p=')) {
  var targetPage = location.search.split('p=')[1];
  loadToPage(+targetPage);
}

var lastScrollTop = 0;
var collectionFilter = document.querySelector('.collection-filter');
var header = document.querySelector('#SiteHeader');

window.addEventListener('scroll', function () {
  var st = window.pageYOffset || document.documentElement.scrollTop;
  if (st < 20) return;
  if (st > lastScrollTop) {
    // downscroll code

    header.classList.add('hider');
    if (collectionFilter) {
      collectionFilter.style.top = `-${collectionFilter.offsetHeight}px`;
    }
  } else {
    // upscroll code

    header.classList.remove('hider');
    if (collectionFilter) {
      collectionFilter.style.top = header.offsetHeight + 'px';
    }
  }

  // For Mobile or negative scrolling
  lastScrollTop = st <= 0 ? 0 : st;
}, false);

// Linked Products based on SKU
function fetchAllProducts() {
  let i = 1,
    urls = []

  do {
    urls.push(fetch(`/collections/grafikr-all-products-linked?view=linked&page=${i}&filter.v.availability=1&filter.v.availability=0`))
    i++
  } while (i <= theme.settings.productPages)

  Promise.all(urls).then(responses =>
    Promise.all(responses.map(res => res.json()))
  ).then(data => {
    data = [].concat.apply([], data);

    window.products = data;
    sessionStorage.setItem('allProducts', JSON.stringify(data)) // Save in sessionStorage

    loadLinkedProducts();
    collectionColorSwatches();
  })
}

if (!sessionStorage.getItem('allProducts')) {
  fetchAllProducts();
} else {
  window.products = JSON.parse(sessionStorage.getItem('allProducts'));
  loadLinkedProducts();
  collectionColorSwatches();
}

function loadLinkedProducts() {
  var linkedProductContainer = document.getElementById('linkedProductContainer');

  if (location.pathname.includes('/products/') && linkedProductContainer) {
    var container = document.querySelector('[data-product-id]');
    var productTemplate = document.body.dataset.productTemplate;
    var productID = +container.dataset.productId;
    var currentProduct = window.products.find(product => product.id === productID);

    if (currentProduct) {
      var currentSku = currentProduct.sku.split('-')[0];
      var linkedProducts = window.products.filter(product => {
        var currentTemp = product.sku?.split('-')[0];
        if (currentTemp === currentSku) {
          return product;
        }
      });


      var currentColorElem = document.querySelector('[data-current-color]');
      var productCount = linkedProducts.length;
      var title = currentProduct.title.split(' ').pop();

      if (productTemplate === 'preorder') {
        title = currentProduct.title.split(' ')[Array.length + 1];
      }

      linkedProductContainer.dataset.itemLength = productCount;

      linkedProductContainer.insertAdjacentHTML('beforeend', `
            <a href="${currentProduct.url}" class="carousel-cell">
                <img src="${currentProduct.image}" alt="${title}" data-color="${title}" class="active">
            </a>
            `)
      linkedProducts.forEach(linked => {
        if (linked.id === currentProduct.id) {
          return;
        }
        var title = linked.title.split(' ').pop();

        if (productTemplate === 'preorder') {
          title = currentProduct.title.split(' ')[Array.length + 1];
        }

        linkedProductContainer.insertAdjacentHTML('beforeend', `
            <a href="${linked.url.split('?')[0]}" class="carousel-cell" data-color="${title}">
                <img src="${linked.image}" alt="${linked.title}">
            </a>
            `)
      });
      var linkedColorElement = linkedProductContainer.querySelectorAll('[data-color]');
      var activeLinked = linkedProductContainer.querySelector('.active');

      if (currentColorElem) {
        linkedColorElement.forEach(element => {
          element.addEventListener('mouseover', function () {
            currentColorElem.textContent = element.dataset.color;
          });
          element.addEventListener('mouseleave', function () {
            currentColorElem.textContent = activeLinked.dataset.color;
          });
        });
      }
      if (linkedProducts.length >= 4) {
        new Flickity(document.getElementById('linkedProductContainer'), {
          arrowShape: {
            x0: 20,
            x1: 60, y1: 40,
            x2: 60, y2: 35,
            x3: 25
          },
          cellAlign: 'left',
          contain: true,
          freeScroll: true,
          groupCells: false,
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
        });
      } else {
        new Flickity(document.getElementById('linkedProductContainer'), {
          arrowShape: {
            x0: 20,
            x1: 60, y1: 40,
            x2: 60, y2: 35,
            x3: 25
          },
          cellAlign: 'left',
          contain: true,
          freeScroll: true,
          groupCells: true,
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
        });
      }
    }
  }
}

// Color Swatches
function collectionColorSwatches() {
  if (!location.pathname.includes('/products/')) {
    const colorSwatches = document.querySelectorAll('.colour-swatch');
    colorSwatches.forEach(swatch => {
      swatch.innerHTML = '';
      var productID = +swatch.dataset.id;
      var currentProduct = window.products.find(product => product.id === productID);
      if (currentProduct && currentProduct.sku) {
        var currentSku = currentProduct.sku.split('-')[0];
        var linkedProducts = window.products.filter(product => {
          var currentTemp = product.sku?.split('-')[0];
          if (currentTemp === currentSku) {
            return product;
          }
        });

        theme.config.bpSmall ? n = 4 : n = 5;
        linkedProducts.slice(0, n).forEach(linked => {
          if (linked.tag.length > 0) {
            swatch.insertAdjacentHTML('beforeend', `
          <a class="swatch swatch-${linked.tag}" href="${linked.url.split('?')[0]}" title="${linked.tag}">
          <span class="swatch--inner"></span>
          </a>
        `)
          }
        });
        if (linkedProducts.length > n) {
          var spliceCount = document.createElement('span');
          spliceCount.innerHTML = '+ ' + linkedProducts.splice(n).length;
          swatch.appendChild(spliceCount);
        }
      }
    });
  }
}

// Geo Dropdown


const currentStoreData = window.currentStore;
const externalStoresData = window.countryBlocks;

/**************************** Helper ****************************/
function populateStoreElem(template, storeObj, showTitle = true, showImage = true, lazyImg = true) {

  const regionalImg = template.querySelector('[data-store-image]');
  const regionalText = template.querySelector('[data-store-title]');
  template.setAttribute('href', storeObj.url);
  template.setAttribute('title', storeObj.name);

  if (storeObj['highlight'] === null && storeObj.highlight === true) {
    template.classList.add('highlight');
  }
  // debugger
  if (showImage) {
    regionalImg.setAttribute('src', storeObj.icon);
    regionalImg.setAttribute('alt', storeObj.name);
    if (lazyImg) {
      regionalImg.setAttribute('loading', 'lazy');
    }
  }
  else {
    regionalImg.remove();
  }

  if (showTitle) {
    regionalText.innerText = storeObj.name;
  }
  else {
    regionalText.remove();
  }

  return template

}


/**************************** Dropdown ****************************/

const geoDropdowns = document.querySelectorAll('.js-geo-dropdown')
if (geoDropdowns && externalStoresData) {
  // Open selector
  const openGeoDropdown = (elem) => { elem.classList.add('open') };
  // Close selector
  const closeGeoDropdown = (elem) => { elem.classList.remove('open'); }

  geoDropdowns.forEach((geoDropdown) => {

    const dropdownSettings = JSON.parse(geoDropdown.dataset.settings);
    const redirectStoreObj = geoDropdown.querySelector('.js-geo-dropdown__store.js-geo-dropdown__store.js-template');
    const fragment = document.createDocumentFragment();
    const currentStoreHeader = geoDropdown.querySelector('.js-geo-dropdown__current-store-header');
    const currentStore = geoDropdown.querySelector('.js-geo-dropdown__current-store');
    const redirectStores = geoDropdown.querySelector('.js-geo-dropdown__redirect-stores');

    const openGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--open');
    const closeGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--close');
    const toggleGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--toggle');

    openGeoDropdownElems.forEach(openGeoDropdownElem => {
      openGeoDropdownElem.addEventListener('click', () => {
        openGeoDropdown(geoDropdown);
      })
    })

    closeGeoDropdownElems.forEach(closeGeoDropdownElem => {
      closeGeoDropdownElem.addEventListener('click', () => {
        closeGeoDropdown(geoDropdown);
      })
    })

    /* Close whan clicking outside */
    document.addEventListener('click', function (event) {
      var isClickInside = geoDropdown.contains(event.target);

      if (!isClickInside) {
        closeGeoDropdown(geoDropdown);
      }
    });

    toggleGeoDropdownElems.forEach(toggleGeoDropdownElem => {
      toggleGeoDropdownElem.addEventListener('click', () => {
        if (geoDropdown.classList.contains('open')) {
          closeGeoDropdown(geoDropdown);
        } else {
          openGeoDropdown(geoDropdown);
        }
      })
    });

    if (dropdownSettings.imagePosition === 'right') {
      geoDropdown.classList.add('image-position--right')
    }
    if (dropdownSettings.roundedImages) {
      geoDropdown.classList.add('images--rounded')
    }

    // Add content to Dropdown - Current store header
    populateStoreElem(currentStoreHeader, currentStoreData, dropdownSettings.showLanguageTitleInHeader, dropdownSettings.showImages, lazyImg = false)
    // Add content to Dropdown - Current store
    populateStoreElem(currentStore, currentStoreData, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages)

    // Add content to Dropdown - External stores
    if (externalStoresData) {
      externalStoresData.forEach(externalStore => {
        const template = redirectStoreObj.cloneNode(true);
        template.classList.remove('js-template');
        fragment.appendChild(populateStoreElem(template, externalStore, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages));
      });
    }

    redirectStoreObj.remove();
    redirectStores.appendChild(fragment);

  })//End foreach
} else {
  // Hide dropdowns if empty
  geoDropdowns.forEach((geoDropdown) => {
    geoDropdown.style.display = 'none';
  });
}

custom.CartProgress = (function () {
  document.addEventListener('click', async (e) => {
    if (e.target.hasAttribute('data-cart-remove')) {
      e.preventDefault();
      const url = new URL(e.target.href);
      url.pathname = theme.routes.cartChange;
      await fetch(url);
      document.dispatchEvent(new CustomEvent('cart:build'));
      updateProgress();
    }
  });

  var cartProgressContainer = document.querySelector('[data-cart-progress]');
  if (cartProgressContainer) {
    var cartProgressGoal = Number(cartProgressContainer.dataset.cartProgressGoal) * 100;
    var cartProgressGoalReachedText = cartProgressContainer.dataset.goalReachedText;
    var cartProgressGoalNotReachedText = cartProgressContainer.dataset.progressText;
    var cartProgressMessageText = cartProgressContainer.querySelector('[data-cart-progress-text]');
    var cartProgressBarPercentageEl = cartProgressContainer.querySelector('[data-cart-progress-bar-percentage]');

    document.addEventListener('ajaxProduct:added', updateProgress);
    document.addEventListener('quickshop:added', updateProgress);
    document.addEventListener('cart:updated', updateProgress);

    function updateProgress() {
      fetch(theme.routes.cart)
        .then(function (res) {
          return res.json();
        })
        .then(function (cartData) {
          var newProgressPercent = cartData.total_price / cartProgressGoal * 100;
          if (newProgressPercent > 100) newProgressPercent = 100;
          cartProgressBarPercentageEl.style.width = '' + newProgressPercent + '%';

          if (newProgressPercent >= 100) {
            cartProgressMessageText.innerHTML = cartProgressGoalReachedText;
          } else {
            var missingMoney = cartProgressGoal - cartData.total_price;
            var missingMoneyText = theme.Currency.formatMoney(missingMoney, theme.settings.moneyFormat)
            cartProgressMessageText.innerHTML = cartProgressGoalNotReachedText.replace('--amount--', missingMoneyText);
          }
        })
    }
  }
})();

var scrollUpCollection = document.querySelector('[data-scroll-up]');
var scrollDownCollection = document.querySelector('[data-scroll-down]');

if (scrollUpCollection && scrollDownCollection) {

  scrollDownCollection.addEventListener('click', function () {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  })
  scrollUpCollection.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  })
}


// Hacky solution to attach Geo Dropdown to built-in drawer dropdown tab on mobile
custom.geopDropdownMobileAttach = (function () {
  var geopDropdownMobileAttach = {
    init: function () {
      var selectors = {
        geoDropdownContainer: document.querySelector('.mobile-nav .geo-dropdown-mobile'),
        geoDropdownStores: document.querySelector('.mobile-nav .geo-dropdown-mobile .geo-dropdown__stores'),
        geoDropdownChevron: document.querySelector('.mobile-nav .geo-dropdown-mobile .chevron-down'),
        geoDropdownToggle: document.querySelector('.mobile-nav .geo-dropdown-mobile .mobile-nav__toggle button'),
        geoDropdownSublist: document.querySelector('.mobile-nav .geo-dropdown-mobile .mobile-nav__sublist')
      };

      selectors.geoDropdownChevron.remove();
      selectors.geoDropdownStores.className = 'geo-dropdown__stores-mobile';

      document.querySelector('.mobile-nav .geo-dropdown-mobile .mobile-nav__item .mobile-nav__link').appendChild(selectors.geoDropdownStores);

      [selectors.geoDropdownToggle, document.querySelector('.mobile-nav .geo-dropdown-mobile .mobile-nav__link--top-level')].forEach(elm => {
        elm.addEventListener('click', geoDropdownMobile);
      });

      function geoDropdownMobile() {
        var sublist = selectors.geoDropdownSublist;
        sublist.classList.add('is-transitioning');

        selectors.geoDropdownSublist.addEventListener('transitionend', function () {
          sublist.classList.remove('is-transitioning');
        });

        if (!selectors.geoDropdownToggle.classList.contains('is-open') && !selectors.geoDropdownSublist.classList.contains('is-open')) {

          [selectors.geoDropdownSublist, selectors.geoDropdownToggle].forEach(elm => {
            elm.classList.add('is-open');
          });

          selectors.geoDropdownContainer.classList.add('open');
          selectors.geoDropdownSublist.style.height = selectors.geoDropdownStores.offsetHeight + 24 + 'px';

          [selectors.geoDropdownToggle].forEach(elm => {
            elm.setAttribute('aria-open', true);
            elm.setAttribute('aria-expanded', true);
          });

        } else {

          [selectors.geoDropdownSublist, selectors.geoDropdownToggle].forEach(elm => {
            elm.classList.remove('is-open');
          });

          selectors.geoDropdownContainer.classList.remove('open');
          selectors.geoDropdownSublist.style.height = '0px';

          [selectors.geoDropdownToggle].forEach(elm => {
            elm.setAttribute('aria-open', false);
            elm.setAttribute('aria-expanded', false);
          });
        }
      }
    },
  }
  geopDropdownMobileAttach.init();
})();


// Add to cart function, exclusively on handheld devices
if (custom.stickyCartBtn) {
  custom.addToCartMobile = (function () {
    var $namespace = document.querySelector('.template-product');
    var $container = document.querySelector('.product-single__form');
    var addToCartMobile = {

      offsetHandler: function () {
        if ($container) {
          let stickyContainer = $container.className + '--sticky';
          let pageOffset = 200;
          stickyContainer.toString();

          setInterval(() => {
            if (window.scrollY >= pageOffset) {
              $container.classList.add(stickyContainer);
            } else {
              $container.classList.remove(stickyContainer);
            }
            if (window.scrollY >= pageOffset * 10) {
              $container.classList.remove(stickyContainer);
            }
          }, 500);
        }
      },

      init: function () {
        const nodes = {
          salesPoint: document.querySelector('.product-block--sales-point'),
          productSelect: document.querySelector('[data-product-select]'),
          addToCartBtn: document.querySelector('[data-add-to-cart]')
        };

        const config = {
          err: 'select-error',
          salesPoint: nodes.salesPoint,
          productSelect: nodes.productSelect,
          addToCartBtn: nodes.addToCartBtn
        };

        // Watch for when Klaviyo Back in Stock trigger is loaded into the DOM
        (function () {
          var body = document.body;
          const observer = new MutationObserver(() => {
            if (body.contains(document.querySelector('.klaviyo-bis-trigger'))) {
              setTimeout(() => {
                var bisTrigger = document.querySelector('.klaviyo-bis-trigger');

                if (bisTrigger) {
                  let bisContent = bisTrigger.textContent;
                  let text = bisContent.split('-').pop().trim();
                  bisTrigger.textContent = text;
                  bisTrigger.classList.remove('btn--secondary');
                }
              }, 1000);

              observer.disconnect();
            }
          })
          observer.observe(body, { childList: true });
        })();

        config.productSelect.addEventListener('change', (evt) => {
          let options = evt.target.options;
          let isAvailable = options[evt.target.selectedIndex].dataset.isAvailable;

          if (isAvailable === 'false') {
            [config.salesPoint, config.addToCartBtn].forEach(elm => {
              elm.classList.add('hide');
            });
          } else {
            [config.salesPoint, config.addToCartBtn].forEach(elm => {
              elm.classList.remove('hide');
            });
          }
        });

        config.addToCartBtn.addEventListener('click', (evt) => {
          if (config.productSelect.selectedIndex === 0) {
            evt.preventDefault();
            dispatchError();
          }
        });

        dispatchError = function () {
          if (!config.productSelect.classList.contains(config.err)) {
            config.productSelect.classList.add(config.err);

            config.productSelect.addEventListener('animationend', () => {
              config.productSelect.classList.remove(config.err);
            });
          }
        }
      }
    };

    if ($namespace && theme.config.bpSmall) {
      addToCartMobile.init();
    }

    addToCartMobile.offsetHandler();
  })();
}

// Cart item focus/scroll into view function
custom.cartItemScrollIntoView = (function () {
  var selectors = {
    scrollable: '#CartDrawer .drawer__scrollable',
    inner: '#CartDrawer .drawer__inner'
  };

  function focusItem(callback) {
    var id = callback.detail.product['variant_id'];
    var getItem = setInterval(() => {
      var result = document.querySelector(`.cart__item[data-item-id="${id}"]`);
      var drawerDiv = document.querySelector(selectors.scrollable);

      if (result) {
        clearInterval(getItem);

        result.scrollIntoView(false);
        drawerDiv.scrollTop = 0;
      }
    }, 500);
  }

  document.addEventListener('ajaxProduct:added', (item) => { focusItem(item); });
  document.addEventListener('quickshop:added', (item) => { focusItem(item); });
})();


// Column Carousel using Flickity sliders
custom.ColumnCarousel = (function () {
  var ColumnCarousel = ColumnCarousel || {};
  var desktopFlickityRec = document.documentElement.clientWidth || window.innerWidth;
  var sliders = document.querySelectorAll('.column-carousel');

  ColumnCarousel = function () {
    sliders.forEach((slider) => {
      let disableDesktop = slider.dataset.disableOnDesktop;

      if (desktopFlickityRec > 600 && disableDesktop === 'true') {
        setTimeout(() => {
          slider.classList.remove('flickity-enabled');
          slider.removeAttribute('data-slider');

          let buttons = Array.from(slider.querySelectorAll('.flickity-button'));
          buttons.forEach((btn) => {
            btn.remove();
          });
          return;
        });
      }
      new window.Flickity(slider, {
        arrowShape: {
          x0: 20,
          x1: 60,
          y1: 40,
          x2: 60,
          y2: 35,
          x3: 25
        },
        cellAlign: 'left',
        contain: true,
        freeScroll: false,
        groupCells: true,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        autoPlay: desktopFlickityRec <= 600 ? true : false
      });
    });
  };
  if (sliders) {
    return ColumnCarousel;
  }
})();

new custom.ColumnCarousel;